import React, { useState } from 'react';
import { Container, Box, Typography, TextField, Button } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import brandConfig from './brandConfig'; 

const MailingSection = () => {
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [status, setStatus] = useState('');


  const scriptURL = 'https://script.google.com/macros/s/AKfycbxW6iYXkRBwUtjC16OZFH6s7_OWhyMxuEhuPFOIfK2zXnHOycb7ZwHJvF4AsOVUeIDtvQ/exec';

  const domain = window.location.hostname.replace(/^www\./, '');
  const currentBrand = brandConfig[domain] || brandConfig.default;
  const country = currentBrand.country;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = { name, email, phone, country };
    try {
      const response = await fetch(scriptURL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      if (response.ok) {
        setStatus('success');
        setName('');
        setEmail('');
        setPhone('');
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error('Error al enviar:', error);
      setStatus('error');
    }
  };

  return (
    <Container sx={{ py: 8 }}>
      <Typography variant="h4" align="center" gutterBottom>
        <Trans i18nKey="mailing.title">Suscríbete a nuestro mailing</Trans>
      </Typography>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          mt: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <TextField
          label={t('mailing.nameLabel', 'Nombre')}
          variant="outlined"
          fullWidth
          sx={{ maxWidth: 400, mb: 2 }}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <TextField
          label={t('mailing.emailLabel', 'Correo Electrónico')}
          variant="outlined"
          fullWidth
          sx={{ maxWidth: 400, mb: 2 }}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <TextField
          label={t('mailing.phoneLabel', 'Teléfono')}
          variant="outlined"
          fullWidth
          sx={{ maxWidth: 400, mb: 2 }}
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
        <Button variant="contained" color="primary" type="submit" sx={{ mt: 2 }}>
          {t('mailing.subscribeButton', 'Suscribirse')}
        </Button>
        {status === 'success' && (
          <Typography variant="body2" sx={{ mt: 2, color: 'green' }}>
            {t('mailing.successMessage', '¡Gracias por suscribirte!')}
          </Typography>
        )}
        {status === 'error' && (
          <Typography variant="body2" sx={{ mt: 2, color: 'red' }}>
            {t('mailing.errorMessage', 'Hubo un error. Por favor, inténtalo de nuevo.')}
          </Typography>
        )}
      </Box>
    </Container>
  );
};

export default MailingSection;
